export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7488.a81ec047.jpg";